import { registerSoundImplementation } from '~/api/player'

window.funkwhale = {
  registerSoundImplementation
}
